<template>
  <div class="hintprompt">{{markedwords}}</div>
</template>

<script>
export default {
  components: {},
  props: {
    markedwords: {
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: { initialize() {} },
  mounted() {},
  created() {
    this.initialize();
  },
  updated() {},
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped >
@import './index.styl';
</style>



// WEBPACK FOOTER //
// src/components/wx-hintprompt/index.vue